<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown
              [options]="occProfileList"
              formControlName="occProfileId"
              optionLabel="occProfileName"
              optionValue="occProfileId"
              [filter]="true"
              placeholder="Select Occ Profile"
              appendTo="body"
              inputId="occProfileId">
            </p-dropdown>
            <label for="occProfileId">Occupancy Profile</label>
            @for (validation of validationMessages.occProfileId; track validation) {
              <span>
                @if (form1.get('occProfileId').hasError(validation.type) &&
                  (form1.get('occProfileId').dirty || form1.get('occProfileId').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Low End Expected % -->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lowEndExpOccPCT" id="lowEndExpOccPCT" type="number" pInputText>
            <label for="lowEndExpOccPCT">Low End Expected %</label>
            @for (validation of validationMessages.lowEndExpOccPCT; track validation) {
              <span>
                @if (form1.get('lowEndExpOccPCT').hasError(validation.type) &&
                  (form1.get('lowEndExpOccPCT').dirty || form1.get('lowEndExpOccPCT').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- High End Expected % -->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="highEndExpOccPCT" id="highEndExpOccPCT" type="number" pInputText>
            <label for="highEndExpOccPCT">High End Expected %</label>
            @for (validation of validationMessages.highEndExpOccPCT; track validation) {
              <span>
                @if (form1.get('highEndExpOccPCT').hasError(validation.type) &&
                  (form1.get('highEndExpOccPCT').dirty || form1.get('highEndExpOccPCT').touched)) {
                  <small class="p-invalid"
                    >
                    {{ validation.message }}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (occDeviationId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!occDeviationId) {
                <button pButton [disabled]="form1.invalid" class="btn-addt p-button" (click)="formAdd()">Add</button>
              }

              @if (occDeviationId) {
                <button pButton  [disabled]="form1.invalid" class="btn-upt p-button" (click)="formUpdate()">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>